/* eslint-disable indent */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useRef } from "react";
import urls from "../../../api/urls";
import API from "../../../api";
import Heading from "../../../components/Heading";
import {
  message,
  Table,
  Input,
  Divider,
  Button,
  Col,
  DatePicker,
  Select,
  Tooltip,
} from "antd";
import axios from "axios";
import Smcs_Loader from "../../../assests/images/loader-new.gif";
import hardware_print_icon from "../../../assests/images/hardwarePrinter.png";
import print_icon from "../../../assests/images/printIcon.svg";
import download_icon from "../../../assests/images/master/download.svg";
import {
  serialNum,
  getStartAndEndDate,
  capitaliseWithHyphen,
  formatReceiverAddress,
  splitReceiverName,
  getCurretRole,
} from "../../../utils";
import refresh from "../../../assests/images/retry-icon.svg";
import disable_refresh from "../../../assests/images/disable-retry-icon.svg";
import { ReactComponent as Download_pin_icon } from "../../../assests/images/SVG/download-pin.svg";
import { getPremiseId } from "../../../utils/worker";
import EllipsisWithTooltip from "../../../components/EllipsisWithToolTip";
import "../../../views/Master/PincodeMaster/style.scss";
import FileUpload from "./fileUpload";
import moment from "moment";
import { dateFormat_dmy } from "../../../utils";
import view_file from "../../../assests/images/view-file.svg";
import { FilterFilled } from "@ant-design/icons";
import useCustomNavigate from "../../../components/customNavigationHook";
function BulkBooking() {
  const navigate = useCustomNavigate();
  const [inputSearchValue, setInputSearchValue] = useState("");
  const [loading, setLoading] = useState(false);
  const [pageSize, setPageSize] = useState(20);
  const [tableData, setTableData] = useState([]);
  const [pageNum, setPageNum] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [pendingPresent, setPendingPresent] = useState(false);
  const [filterClient, setFilterClient] = useState(null);
  const [filteredColumn, setFilteredColumn] = useState({});
  const [clientList, setClientList] = useState([]);
  const [printer, setPrinter] = useState(null);
  const { RangePicker } = DatePicker;
  const premiseId = getPremiseId();
  const currentEnv = process.env.REACT_APP_ENV;

  const [dateRange, setDateRange] = useState({
    fromDate: moment().subtract(1, "days"),
    dateFormat_dmy,
    toDate: moment(new Date(), dateFormat_dmy),
  });

  const isClientAdmin = getCurretRole();

  const disabledDate = (current) => {
    return current && current > moment().endOf("day");
  };
  const {
    GET_BULK_BOOKING_LIST,
    GET_CLIENT_LIST_NEW,
    GET_CLIENT_INNO,
    RETRY_BULK_BOOK,
    GET_BULK_BOOK_INFO,
    GENERATE_BULK_BOOKING_PDF,
    PRINT_RECEIPT_BULK_BOOKING,
    GET_BULK_BOOK_PDF_V2,
  } = urls;
  let sampleUrl = null;

  if (!isClientAdmin) {
    sampleUrl =
      "https://prod-smile-uploadfiles.s3.ap-south-1.amazonaws.com/booking/Account_Booking_Bulk_Format_New.xls";
  } else {
    sampleUrl =
      "https://prod-smile-uploadfiles.s3.ap-south-1.amazonaws.com/booking/Account_Booking_Bulk_Format_New.xls";
  }

  useEffect(() => {
    const fetchPrinter = async () => {
      try {
        // STANDARD PORT FOR ZEBRA PRINTER
        const availablePrinters = await axios.get(
          "http://localhost:9100/available"
        );
        // console.log("availablePrinters: ", availablePrinters?.data?.printer[0]);
        setPrinter(availablePrinters?.data?.printer[0] || null);
        //  REQUEST TO INITIATE PRINTER
        await axios.post("http://localhost:9100/write", "", {
          headers: {
            "Content-Type": "text/plain",
          },
        });
      } catch (err) {
        // console.log("ZEBRA PRINTER NOT FOUND ");
        return;
      }
    };
    if (!printer) {
      fetchPrinter();
    }
  }, []);

  useEffect(() => {
    if (!isClientAdmin) {
      getClients();
    }
  }, []);

  const getClients = async () => {
    setLoading(true);
    const companyId =
      JSON.parse(localStorage.getItem("selectedCompany"))?.key || null;
    let res;
    if (currentEnv === "qa") {
      res = await API.Api(
        GET_CLIENT_LIST_NEW + companyId
      ).getWithPremiseHeader();
    } else {
      res = await API.Api(GET_CLIENT_INNO).getwithParams({
        company_id: companyId,
      });
    }

    if (res.status) {
      const response = res?.response?.data?.data || [];
      const clients = response?.map((e, i) => ({
        key: i,
        label: capitaliseWithHyphen(e?.ClientName),
        value: e?.ClientName,
        department: e?.Departments,
      }));
      // localStorage.setItem("allClients", JSON.stringify(clients) || null);
      setClientList(clients);
      setLoading(false);
    } else {
      message.error("Something went wrong");
      setLoading(false);
    }
  };

  useEffect(() => {
    getTableData(pageNum, pageSize);
  }, []);

  useEffect(() => {
    if (pendingPresent) {
      const interval = setInterval(() => {
        getTableData(0, pageSize, dateRange?.fromDate, dateRange?.toDate);
      }, 5000);

      return () => clearInterval(interval);
    }
  }, [pendingPresent]);

  const branchId =
    JSON.parse(localStorage.getItem("selectedCompany"))?.key || null;

  const getTableData = async (
    pageNum,
    pageSize,
    startDate,
    endDate
    //clientId = null
  ) => {
    let url =
      `${
        GET_BULK_BOOKING_LIST + premiseId.split("Bearer ")[1]
      }?pageNo=${pageNum}&pageSize=${pageSize}` +
      getStartAndEndDate(
        startDate ? startDate : null,
        endDate ? endDate : null,
        dateFormat_dmy
      );
    //(clientId ? `&clientId=${clientId}` : "");

    let response = await API.Api(url).getWithUserNPremiseHeader();
    if (response?.status) {
      setLoading(false);
      const res = response?.response?.data;
      setPendingPresent(res?.data?.some((e) => !e.status));
      setTableData(res);
    } else {
      message.error(response?.response?.data?.message || "Network Error");
    }
  };

  const handlePrinting = async (payload) => {
    // Processed address fields
    for (const [index, item] of payload.entries()) {
      const processedAddress = formatReceiverAddress(
        item?.receiverAddressLine1,
        item?.receiverAddressLine2
      );

      const receiverName = splitReceiverName(item?.receiverName);

      const baseData = {
        ...receiverName,
        documentNumber: item?.documentNumber,
        bookingType: item?.bookingType.toLowerCase() === "dox" ? "DOX" : "NDOX",
        bookingService:
          item?.bookingService?.toLowerCase() === "standard"
            ? "STD"
            : item?.bookingService?.toLowerCase() === "fast track"
            ? "FST"
            : "VP",
        bookindTravelType:
          item?.bookindTravelType?.toLowerCase() === "surface" ? "SUR" : "AIR",
        currentShipment: index + 1, // Replace this with appropriate logic for currentShipment
        senderName: item?.senderName,
        receiverMobileNumber: item?.receiverMobileNumber,
        receiverCity: item?.receiverCity,
        deliveryPincode: item?.deliveryPincode,
        receiverAddressLine1: processedAddress[0] || "",
        recieverAddressLine2: processedAddress[1] || "",
        recieverAddressLine3: processedAddress[2] || "",
        recieverAddressLine4: processedAddress[3] || "",
        recieverAddressLine5: processedAddress[4] || "",
        recieverAddressLine6: processedAddress[5] || "",
        recieverAddressLine7: processedAddress[6] || "",

        senderMobileNumber: item?.senderMobileNumber || "",
        totalShipments: parseInt(payload?.length),
      };

      const printData = async (data) => {
        setLoading(true);
        try {
          const updatedTemplate = await fetch("/printingTemplate.txt")
            .then((response) => response?.text())
            .then((res) =>
              res?.replace(/{{(.*?)}}/g, (_, key) => {
                return data[key?.trim()] || "";
              })
            )
            .catch((err) => console.log(err));

          const printingData = JSON.stringify({
            device: printer,
            data: updatedTemplate,
          });

          await axios.post("http://localhost:9100/write", printingData, {
            headers: {
              "Content-Type": "text/plain",
            },
          });
          setLoading(false);
        } catch (err) {
          setLoading(false);
          message.error("UNABLE TO PRINT");
          // console.log(err, "UNABLE TO PRINT");
        }
      };

      // Print for the main item
      const mainData = {
        ...baseData,
        documentNumber: item?.documentNumber,
      };
      await printData(mainData);
    }

    // Check and print for child shipments
    // if (
    //   payload?.childShipmentDetails &&
    //   Array.isArray(payload?.childShipmentDetails) &&
    //   payload?.childShipmentDetails?.length > 0
    // ) {
    //   for (const child of payload.childShipmentDetails) {
    //     currentShipment = currentShipment + 1;
    //     const childData = {
    //       ...baseData,
    //       documentNumber: child?.childAwbNumber,
    //       currentShipment: currentShipment,
    //     };
    //     await printData(childData);
    //   }
    // }
  };
  const generatePDF = async (params) => {
    setLoading(true);
    try {
      const responses = await API.Api(
        GET_BULK_BOOK_PDF_V2 + params
      ).getWithResponseType();
      // const responses = await axios.get(GET_BULK_BOOK_PDF_V2 + params, {
      //   responseType: "arraybuffer",
      // });
      // Create a Blob from the response data
      const pdfBlob = new Blob([responses.data], { type: "application/pdf" });
      // Create a URL for the Blob
      const downloadUrl = URL.createObjectURL(pdfBlob);
      // Create a link element and trigger the download
      const link = document.createElement("a");
      link.href = downloadUrl;
      link.download = "smile.pdf"; // Set the desired file name
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      // Revoke the object URL to free up memory
      URL.revokeObjectURL(downloadUrl);
    } catch (error) {
      console.error("Error downloading PDF:", error);
    } finally {
      setLoading(false);
    }
  };

  const printerCallBack = async (params) => {
    setLoading(true);
    let url = `${GET_BULK_BOOK_INFO + +params}`;

    let response = await API.Api(url).getWithAllHeaders();
    if (response?.status) {
      // setLoading(false);
      handlePrinting(response?.response?.data);
      // setTotalLoad(response?.response?.data);
    } else {
      setLoading(false);

      message.error(
        response?.response?.data?.message || "Internal server error."
      );
    }
  };

  const printBulkReceipt = async (params) => {
    setLoading(true);
    try {
      let responses = await API.Api(
        PRINT_RECEIPT_BULK_BOOKING
      ).postWithResponseType({
        bulkBookingId: params,
      });

      // Create a Blob from the response data
      const pdfBlob = new Blob([responses.data], { type: "application/pdf" });
      // Create a URL for the Blob
      const downloadUrl = URL.createObjectURL(pdfBlob);
      // Create a link element and trigger the download
      const link = document.createElement("a");
      link.href = downloadUrl;
      link.download = "smile.pdf"; // Set the desired file name
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      // Revoke the object URL to free up memory
      URL.revokeObjectURL(downloadUrl);
    } catch (error) {
      console.error("Error downloading PDF:", error);
    }
    setLoading(false);
  };

  const retryUpload = async (id) => {
    setLoading(true);
    const res = await API.Api(RETRY_BULK_BOOK + id).putCustomIdHeader();

    if (!res?.status) {
      setLoading(false);
      message.error(res?.response?.data?.message || "Internal server error.");
    } else {
      getTableData(0, pageSize, dateRange.fromDate, dateRange.toDate);
      setLoading(false);
    }
  };

  const columns = [
    {
      title: "Sl No",
      align: "center",
      render: (a, b, idx) => serialNum(pageSize, pageNum, idx),
      width: 40,
    },
    {
      title: "Client Name",
      dataIndex: "clientName",
      key: "clientName",
      width: 122,
      ellipsis: true,
      // render: (text, record) => <EllipsisWithTooltip text={text} />,
      render: (text, record) => <span>{text}</span> || "N/A",
    },
    {
      title: "Uploaded File",
      dataIndex: "originalFileUrl",
      key: "originalFileUrl",
      width: 60,
      ellipsis: true,
      //render: (text, record) => <span>{text}</span> || "N/A",

      render: (text, record) => (
        <a href={text}>
          <img src={view_file} alt="uploaded file" width={15} />
          {"View File"}
        </a>
      ),
    },

    {
      title: (
        <span>
          Succcess <br /> Count
        </span>
      ),
      dataIndex: "successCount",
      key: "successCount",
      width: 60,
      render: (text, record) => (text == null ? "N/A" : text),
    },
    {
      title: (
        <span>
          Failed <br /> Count
        </span>
      ),
      dataIndex: "successCount",
      key: "successCount",
      width: 60,
      render: (text, record) =>
        record?.successCount !== null
          ? record?.totalCount - record?.successCount
          : "N/A",
    },
    {
      title: "Failed Orders",
      dataIndex: "returnedFileUrl",
      key: "returnedFileUrl",
      width: 60,
      render: (text, record) =>
        text ? (
          <a href={text}>
            <img src={view_file} alt="failed orders" width={15} />
            {"View File"}
          </a>
        ) : (
          "N/A"
        ),
    },
    {
      title: "Created Date",
      dataIndex: "createdDate",
      key: "createdDate",
      width: 90,
      render: (text, record) => <div>{text || "N/A"}</div>,
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      width: 80,
      render: (text, record) => (
        <>
          <span
            className={`status center ${
              record?.returnedFileUrl && text
                ? record?.successCount > 0
                  ? "partial-success"
                  : "rejected"
                : text
                ? "approved"
                : "inprogress"
            }`}
          >
            {record?.returnedFileUrl && text
              ? record?.successCount > 0
                ? "Partially Success"
                : "Failed"
              : text
              ? "Completed"
              : "In-Progress"}
          </span>
        </>
      ),
    },
    {
      title: "Actions",
      key: "retryTime",
      dataIndex: "retryTime",
      width: 30,
      render: (text, record) => {
        const { retryCount, status, createdDate, retryTime, bulkBookingId } =
          record || {};

        const timestamp =
          retryCount === 0 && !status
            ? createdDate
            : retryCount <= 3
            ? retryTime
            : null;

        if (timestamp && !status) {
          const retryDate = addMinutesToTimestamp(timestamp, 15);
          const currentDate = new Date();
          if (retryDate <= currentDate) {
            return (
              <span className="center">
                <img
                  src={refresh}
                  alt="Retry"
                  className="pointer mr-1"
                  onClick={() => retryUpload(bulkBookingId)}
                />
              </span>
            );
          }
        }
        const status_ =
          record?.returnedFileUrl && text
            ? record?.successCount > 0
              ? "Partially Success"
              : "Failed"
            : text
            ? "Completed"
            : "In-Progress";

        const shouldShowPrinter =
          printer &&
          (status_ === "Partially Success" || status_ === "Completed");

        return (
          <span className="d-flex">
            {record.successCount > 0 && (
              <Tooltip title={"Generate PDF"} placement="right">
                <p
                  className="vbooking-icons"
                  style={{ marginTop: "-5px", marginRight: 10 }}
                  onClick={(e) => {
                    generatePDF(record?.bulkBookingId);
                  }}
                >
                  <img src={download_icon} width={"18px"} className="pointer" />
                </p>
              </Tooltip>
            )}
            {shouldShowPrinter && (
              <Tooltip title={"Printer thermal sticker"} placement="right">
                <p
                  className="vbooking-icons"
                  style={{ marginTop: "-5px", marginRight: 10 }}
                  onClick={(e) => {
                    printerCallBack(record?.bulkBookingId);
                  }}
                >
                  <img
                    src={hardware_print_icon}
                    width={"15px"}
                    className="pointer"
                  />
                </p>
              </Tooltip>
            )}
            {record.successCount > 0 && currentEnv == "qa" && (
              <Tooltip title={"Generate Bulk Receipt"} placement="right">
                <p
                  className="vbooking-icons"
                  style={{ marginTop: "-5px", marginRight: 10 }}
                  onClick={(e) => {
                    printBulkReceipt(record?.bulkBookingId);
                  }}
                >
                  <img src={print_icon} width={"20px"} className="pointer" />
                </p>
              </Tooltip>
            )}
          </span>
        );
      },
    },
  ];

  const addMinutesToTimestamp = (timestamp, minutes) => {
    const [datePart, timePart] = timestamp.split(" ");
    const [year, month, day] = datePart.split("-");
    const [hours, minutesPart, seconds] = timePart.split(":");
    const date = new Date(year, month - 1, day, hours, minutesPart, seconds);

    date.setMinutes(date.getMinutes() + minutes);
    return date;
  };
  const itemRender = (_, type, originalElement) => {
    if (type === "prev") {
      return <a>Previous</a>;
    }
    if (type === "next") {
      return <a>Next</a>;
    }
    return (
      <div>
        <p>{originalElement} </p>
      </div>
    );
  };

  // function handlePageChange(pagenum, pagesize) {
  //   window.scrollTo(0, 0);
  //   setPageNum(pagenum - 1);
  //   setPageSize(pagesize);

  //   getTableData(pagenum - 1, pagesize, dateRange.fromDate, dateRange.toDate);
  // }

  const handlePageChange = (pagination) => {
    getTableData(
      pagination.current - 1,
      pagination.pageSize,
      dateRange.fromDate,
      dateRange.toDate
      //filterClient
    );
    setPageSize(pagination.pageSize);
    setPageNum(pagination.current);
    setCurrentPage(pagination.current);
  };

  const handleDateChange = (e, date) => {
    setDateRange({ fromDate: date[0], toDate: date[1] });
    getTableData(0, 20, date[0], date[1]);
  };

  return (
    <div className="p-1">
      <Heading
        title={"Bulk Booking"}
        extraContent={
          <Col className="">
            <a href={sampleUrl}>
              <Button className="cancel-btn">
                <Download_pin_icon />{" "}
                <span className="ml-1">Download template</span>
              </Button>
            </a>
          </Col>
        }
      />
      <div className="master-main-container lead-client-approval-list p-05">
        <FileUpload
          setLoading={(val) => setLoading(val)}
          hitListApi={() => {
            getTableData(0, pageSize, dateRange.fromDate, dateRange.toDate);
          }}
          pendingPresent={pendingPresent}
          clientList={clientList}
        />
        <Divider />
        <div className="text-right">
          <RangePicker
            value={
              dateRange.fromDate && dateRange.toDate
                ? [
                    moment(dateRange.fromDate, dateFormat_dmy),
                    moment(dateRange.toDate, dateFormat_dmy),
                  ]
                : null
            }
            format={dateFormat_dmy}
            onClick={(e) => e.stopPropagation()}
            disabledDate={(current) => disabledDate(current)}
            onChange={handleDateChange}
            style={{ borderRadius: "5px" }}
          />
        </div>
        <Table
          headerClassName="header"
          className="view-table table-head-sticky mt-05"
          loading={{
            indicator: (
              <img
                src={Smcs_Loader}
                style={{ height: "100px", width: "100px" }}
              />
            ),
            spinning: loading,
          }}
          columns={
            !isClientAdmin
              ? columns
              : columns?.filter((val) => val.key !== "clientName")
          }
          dataSource={tableData?.data || []}
          onChange={handlePageChange}
          pagination={{
            current: currentPage,
            pageSize: pageSize,
            total: tableData?.totalCount,
            pageSizeOptions: ["10", "20", "50", "100"],
            showSizeChanger: true,
            itemRender: itemRender,
          }}
        />
      </div>
    </div>
  );
}

export default BulkBooking;
